import { Alert, Button } from "antd";
import useVersionCheck from "../hooks/useVersionCheck";

export default function UpdateBanner() {
  const { updateAvailable } = useVersionCheck();

  if (!updateAvailable) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 top-0 z-[1000] shadow-md">
      <Alert
        banner
        type="warning"
        showIcon
        message="A new version is available. Please save your work and refresh the page to get the latest updates."
        action={
          <Button
            size="small"
            type="primary"
            className="!border-blue-600 !bg-blue-600 hover:!border-blue-700 hover:!bg-blue-700"
            onClick={() => window.location.reload()}
          >
            Refresh now
          </Button>
        }
      />
    </div>
  );
}
